import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const DashboardBuilderDigestWrapper = lazy(() =>
  import("@scenes/DashboardBuilder/DashboardBuilderDigest/DashboardBuilderDigestWrapper").then((module) => ({
    default: module.DashboardBuilderDigestWrapper,
  }))
);

export const dashboardBuilderDigestNRO: NavigationRoutingObject = {
  Component: DashboardBuilderDigestWrapper,
  componentFeatureFlippers: [],
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("dashboard-builder-sidebar-pill-menu-option", "Dashboard Builder"),
  pageNameForTracking: () => "Dashboard Builder",
  tag: "new",
  featureLimitationKeys: [],
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasViewAppUsagePermission = hasPermission("appGroup", {
      permission: "viewAppUsage",
    });
    const userHasViewReportingPermission = hasPermission("appGroup", {
      permission: "viewReporting",
    });
    return isImpersonating || userHasViewAppUsagePermission || userHasViewReportingPermission;
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("dashboard-builder-alt-keyword-1", "Dashboard Builder")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/report_dashboard/:appGroupId",
  noKnockoutFallback: true,
};
